import { useTranslation } from 'react-i18next';

export default function WhySection() {
  const { t } = useTranslation();

  const features = [
    {
      titleKey: 'why.card1_title',
      descKey: 'why.card1_desc',
      imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20workspace%20with%20laptop%20showing%20spreadsheet%20data%20and%20shopping%20deals%2C%20warm%20cream%20background%2C%20soft%20natural%20lighting%2C%20clean%20aesthetic%2C%20neutral%20tones%2C%20editorial%20style%2C%20professional%20yet%20cozy%20atmosphere%2C%20savings%20concept%2C%20high%20detail&width=800&height=600&seq=why-savings-01&orientation=landscape',
    },
    {
      titleKey: 'why.card2_title',
      descKey: 'why.card2_desc',
      imageUrl: 'https://readdy.ai/api/search-image?query=Calendar%20and%20clock%20concept%20with%20fashion%20items%20on%20warm%20cream%20background%2C%20minimal%20product%20photography%2C%20soft%20diffused%20lighting%2C%20clean%20daily%20update%20theme%2C%20neutral%20warm%20tones%2C%20editorial%20style%2C%20fresh%20modern%20aesthetic&width=800&height=600&seq=why-updates-02&orientation=landscape',
    },
    {
      titleKey: 'why.card3_title',
      descKey: 'why.card3_desc',
      imageUrl: 'https://readdy.ai/api/search-image?query=Verified%20badge%20and%20product%20quality%20check%20concept%20on%20warm%20cream%20background%2C%20minimal%20product%20photography%2C%20soft%20studio%20lighting%2C%20clean%20trust%20and%20verification%20theme%2C%20neutral%20warm%20tones%2C%20editorial%20style%2C%20professional%20quality%20assurance%20aesthetic&width=800&height=600&seq=why-verified-03&orientation=landscape',
    },
  ];

  return (
    <section id="why" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 mb-12">
            <div>
              <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-4">
                {t('why.title')}
              </h2>
            </div>
            <div className="flex items-end">
              <p className="text-foreground-500 text-sm md:text-base leading-relaxed">
                {t('why.subtitle')}
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
            <div className="md:col-span-1 bg-background-100 rounded-lg overflow-hidden">
              <div className="w-full h-48 md:h-56 overflow-hidden">
                <img
                  src={features[0].imageUrl}
                  alt={t(features[0].titleKey)}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <div className="p-5 md:p-6">
                <h3 className="font-heading text-xl font-bold text-foreground-950 mb-2">
                  {t(features[0].titleKey)}
                </h3>
                <p className="text-foreground-500 text-sm leading-relaxed">
                  {t(features[0].descKey)}
                </p>
              </div>
            </div>

            {features.slice(1).map((feature) => (
              <div key={feature.titleKey} className="md:col-span-1 bg-background-100 rounded-lg overflow-hidden">
                <div className="p-5 md:p-6">
                  <h3 className="font-heading text-xl font-bold text-foreground-950 mb-3">
                    {t(feature.titleKey)}
                  </h3>
                  <div className="w-full h-40 md:h-48 overflow-hidden rounded-lg mb-4">
                    <img
                      src={feature.imageUrl}
                      alt={t(feature.titleKey)}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>
                  <p className="text-foreground-500 text-sm leading-relaxed">
                    {t(feature.descKey)}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}